// components/Navbar.jsx

import { useNavigate } from "react-router-dom";

export default function Navbar({ setTransitioning }) {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        /* Paper texture */
        .lp-paper {
          position: fixed;
          inset: 0;
          pointer-events: none;
          z-index: 0;

          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Cfilter id='p'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='400' height='400' filter='url(%23p)' opacity='0.06'/%3E%3C/svg%3E");

          opacity: 0.55;
          mix-blend-mode: overlay;
        }

        /* vignette */
        .lp-vignette {
          position: fixed;
          inset: 0;
          pointer-events: none;
          z-index: 0;

          background: radial-gradient(
            ellipse at center,
            transparent 50%,
            rgba(4, 3, 2, 0.7) 100%
          );
        }

        /* nav */
        .lp-nav {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 100;

          padding: clamp(16px, 3vw, 22px)
            clamp(24px, 6vw, 80px);

          display: flex;
          align-items: center;
          justify-content: space-between;

          background: rgba(8, 6, 4, 0.8);
          backdrop-filter: blur(16px);

          border-bottom: 1px solid var(--rule);
        }

        /* logo */
        .lp-nav-logo {
          font-family: var(--fell);
          font-size: clamp(12px, 2.5vw, 15px);

          letter-spacing: 0.3em;
          color: var(--gold);

          text-transform: uppercase;
          opacity: 0.8;

          cursor: pointer;
          transition: 0.25s ease;
        }

        .lp-nav-logo:hover {
          opacity: 1;
        }

        /* links */
        .lp-nav-links {
          display: flex;
          align-items: center;
          gap: clamp(24px, 4vw, 48px);
        }

        .lp-nav-link {
          font-family: var(--corm);
          font-style: italic;
          font-size: clamp(13px, 2.5vw, 18px);

          color: var(--parch3);
          text-decoration: none;

          letter-spacing: 0.04em;
          transition: color 0.25s ease;
        }

        .lp-nav-link:hover {
          color: var(--parch);
        }

        /* enter button */
        .lp-enter {
          font-family: var(--fell);
          font-size: clamp(10px, 2vw, 12px);

          letter-spacing: 0.2em;
          text-transform: uppercase;

          color: var(--gold);
          background: transparent;

          border: 1px solid rgba(201, 168, 76, 0.3);

          padding: clamp(8px, 2vw, 10px)
            clamp(18px, 4vw, 28px);

          border-radius: 2px;

          cursor: pointer;
          transition: all 0.35s ease;
        }

        .lp-enter:hover {
          background: var(--gold);
          color: var(--ink);
          border-color: var(--gold);
        }

        /* mobile */
        @media (max-width: 768px) {
          .lp-nav {
            padding: 18px 20px;
          }

          .lp-nav-links {
            gap: 16px;
          }

          .lp-nav-link {
            font-size: 14px;
          }

          .lp-enter {
            padding: 8px 16px;
          }
        }
      `}</style>

      <div className="lp-paper" />
      <div className="lp-vignette" />

      <nav className="lp-nav">
        <span
          className="lp-nav-logo"
          onClick={() => navigate("/")}
        >
          MYSAMADHI
        </span>

        <div className="lp-nav-links">
          <a
  href="#aicompanions"
  className="lp-nav-link"
  style={{
    fontWeight: 600,
    letterSpacing: "0.8px",
    textTransform: "uppercase",
    fontSize: "14px",
  }}
>
  AI companions
</a>

<a
  onClick={() => navigate("/about")}
  className="lp-nav-link"
  style={{
    fontWeight: 600,
    letterSpacing: "0.8px",
    textTransform: "uppercase",
    fontSize: "14px",
    cursor: "pointer",
  }}
>
  About
</a>

          {/* <button
            className="lp-enter"
            onClick={() => {
              if (setTransitioning) {
                setTransitioning(true);
              }

              setTimeout(() => {
                navigate("/loading");
              }, 1500);
            }}
          >
            Enter
          </button> */}
        </div>
      </nav>
    </>
  );
}